import { Box, Flex } from 'reflexbox';

import { User } from '@treams/treams-network';
import { Avatar, tokens } from '@treams/treams-ui';

export default function EvaluationAnswerLine({
	children,
	user,
	side,
	withAvatar = false,
	isGoalReview = false,
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	withAvatar?: boolean;
	isGoalReview?: boolean;
	user: User;
}) {
	return (
		<Flex
			flexGrow={1}
			width="100%"
			alignItems="center"
			flexDirection={['column', side === 'left' ? 'row' : 'row-reverse']}
			mt={isGoalReview ? 0 : 3}
			style={{ gap: tokens.gap.element }}
		>
			<Box flexShrink={0} flexGrow={0} opacity={withAvatar ? 1 : 0}>
				<Avatar size={32} user={user} />
			</Box>
			{children}
		</Flex>
	);
}
